import { Link } from 'react-router-dom';
import ArticleCard from '@/components/feature/ArticleCard';
import { getLatestArticles } from '@/mocks/articles';

export default function LatestSection() {
  const latestArticles = getLatestArticles(6);

  return (
    <section className="py-14 md:py-20">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              最新文章
            </h2>
            <p className="text-sm text-foreground-600 mt-2">
              及时了解里番动漫领域的最新动态与推荐
            </p>
          </div>
          <Link
            to="/category/zuixin-fabu"
            className="hidden sm:inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            查看全部
            <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line"></i></span>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {latestArticles.map((article) => (
            <ArticleCard key={article.id} article={article} variant="default" />
          ))}
        </div>

        <div className="text-center mt-8 sm:hidden">
          <Link
            to="/category/zuixin-fabu"
            className="inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            查看全部文章
            <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line"></i></span>
          </Link>
        </div>
      </div>
    </section>
  );
}